import { ApiError, RequestAbortError } from '@/@core/models/api/errors';
import { Response } from '@aleph-alpha/lib-http';
import { KyResponse } from 'ky';

// TODO: adapt types after moving to ky only
export async function handleRequestError<R, T extends KyResponse<R> | Response<R>>(
  makeRequestCallback: () => Promise<T>
): Promise<T> {
  try {
    return await makeRequestCallback();
  } catch (error: unknown) {
    if (isAbortError(error)) {
      throw new RequestAbortError();
    }
    throw new ApiError();
  }
}

function isAbortError(error: unknown): boolean {
  return (
    typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError'
  );
}
